import type { FieldWithOrder } from "./FieldWithOrder";

export function sortOrderedFields(a: FieldWithOrder, b: FieldWithOrder) {
  if (a.order > b.order) return 1;
  if (a.order < b.order) return -1;
  return 0;
}
